import './CustomFilterDeleteButton.scss';

import { IconDelete } from '@hulu-react-style-components/icons';

import Tooltip from '../../../../common/Tooltip';
import type { TooltipProps } from '../../../../common/Tooltip/Tooltip';
import bem from '../../../../utils/bem';
import { CustomFilterVisibility } from './types';

export const CANNOT_DELETE_PUBLIC_FILTER_MESSAGE = 'Only private filters can be deleted';

export interface CustomFilterDeleteButtonProps {
  tooltipId: string;
  filterName: string;
  visibility?: CustomFilterVisibility;
  onClick: () => void;
  iconSize?: string;
  tooltipPlace?: TooltipProps['place'];
  dataTestId?: string;
}

const [block, element] = bem('custom-filter-delete-button');

const CustomFilterDeleteButton = ({
  tooltipId,
  filterName,
  visibility,
  onClick,
  iconSize = '16px',
  tooltipPlace = 'bottom',
  dataTestId,
}: CustomFilterDeleteButtonProps): JSX.Element => {
  const isPrivate = visibility === CustomFilterVisibility.PRIVATE;

  return (
    <Tooltip
      id={tooltipId}
      message={CANNOT_DELETE_PUBLIC_FILTER_MESSAGE}
      place={tooltipPlace}
      disable={isPrivate}
      className={element('tooltip')}
    >
      <button
        type="button"
        className={block()}
        aria-label={`Delete ${filterName}`}
        aria-disabled={!isPrivate}
        disabled={!isPrivate}
        data-testid={dataTestId}
        onClick={onClick}
      >
        <IconDelete width={iconSize} height={iconSize} />
      </button>
    </Tooltip>
  );
};

export default CustomFilterDeleteButton;
